// localStorage-Wrapper fuer Auth-State.
// Single source: { token, user } unter einem Key. Bei Schema-Breaking-Change Key erhoehen.

import type { UserProfile } from "@ms-whiteboard/shared";

const STORAGE_KEY = "ms-whiteboard:auth:v1";

export interface StoredAuth {
  token: string;
  user: UserProfile & { tenantId: string };
}

export function readStoredAuth(): StoredAuth | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as StoredAuth;
  } catch {
    return null;
  }
}

export function writeStoredAuth(auth: StoredAuth): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
}

export function clearStoredAuth(): void {
  localStorage.removeItem(STORAGE_KEY);
}
